import styled from 'styled-components';

export const OverflowYWrapper = styled.div`
  max-height: ${({ height }) => height};
  overflow-y: auto;
`;
